// PREGUNTAS FRECUENTES
const buttonListCollapseEtapas = document.querySelectorAll('#collapseEtapas .card a');

const resetIconStatusEtapa1 = () =>{
  const iconListCollapseEtapas = document.querySelectorAll('#collapseEtapas .card a span');
  for (let i = 0; i < iconListCollapseEtapas.length; i++) {
    iconListCollapseEtapas[i].classList.remove('active');
  }
}

buttonListCollapseEtapas.forEach( (buttonCollapse) => {
  buttonCollapse.addEventListener('click', (event) => {
    let buttonIndex = event.target.firstElementChild;
    if(buttonIndex.classList.contains('active')){
      resetIconStatusEtapa1();
    }
    else{
      resetIconStatusEtapa1();
      buttonIndex.classList.add('active');
    }
  });
});

// PREGUNTAS FRECUENTES ETAPA 2
// const buttonListCollapseEtapa2 = document.querySelectorAll('#collapseEtapa2 .card a');

// const resetIconStatusEtapa2 = () =>{
//   const iconListCollapseEtapa2 = document.querySelectorAll('#collapseEtapa2 .card a span');
//   for (let i = 0; i < iconListCollapseEtapa2.length; i++) {
//     iconListCollapseEtapa2[i].classList.remove('active');
//   }
// }

// buttonListCollapseEtapa2.forEach( (buttonCollapse) => {
//   buttonCollapse.addEventListener('click', (event) => {
//     let buttonIndex = event.target.firstElementChild;
//     if(buttonIndex.classList.contains('active')){
//       resetIconStatusEtapa2();
//     }
//     else{
//       resetIconStatusEtapa2();
//       buttonIndex.classList.add('active');
//     }
//   });
// });